import { APP_URL, CURRENT_TAG } from '@shared/config/raw-env'

export enum RequestKeyWebComponent {
  IMPORT = 'api-web-component-import',
}

const tagPrefix = CURRENT_TAG ? `${CURRENT_TAG}/` : ''

const proxyScriptUrl = `${APP_URL}/${tagPrefix}proxy.js`

export const importMap = {
  imports: {
    ...JSON.parse(import.meta.env.APP_IMPORT_MAP!),
    '@wippy-fe/proxy': `${APP_URL}/${tagPrefix}@wippy-fe/proxy.js`,
    '@wippy-fe/markdown-iframe': `${APP_URL}/${tagPrefix}@wippy-fe/markdown-iframe.js`,
    '@wippy-fe/vue-utils': `${APP_URL}/${tagPrefix}@wippy-fe/vue-utils.js`,
  },
}

/**
 * A script to inject into a child context. A bare string is a classic
 * `<script src>`; `{ src, module: true }` becomes `<script type="module" src>`
 * (required for ESM bundles like the chat shell that use bare imports + the
 * injected import map).
 */
export type ProxyScript = string | { src: string, module?: boolean }

export const scripts: ProxyScript[] = [
  `${APP_URL}/${tagPrefix}@wippy-fe/loading.js`,
  proxyScriptUrl,
  // Thin chat element shell (auto-registers <wippy-chat> & co.; the ~2MB
  // internals lazy-load on first mount). ESM → must be a module script so its
  // bare `vue`/`pinia`/`@wippy-fe/proxy` imports resolve via the import map.
  { src: `${APP_URL}/${tagPrefix}@wippy-fe/chat.js`, module: true },
]

/**
 * Replace hardcoded references to the deprecated front.wippy.ai domain
 * with the current proxy URL.
 */
const DEPRECATED_PROXY_URL_PATTERN = /https?:\/\/front\.wippy\.ai\/(?:[^/"'\s]*\/)?proxy\.js/g

export function replaceProxyUrls(html: string): string {
  return html.replace(DEPRECATED_PROXY_URL_PATTERN, proxyScriptUrl)
}
